import { render, staticRenderFns } from "./flashMessages.vue?vue&type=template&id=47674b40&"
import script from "./flashMessages.vue?vue&type=script&lang=js&"
export * from "./flashMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports